import { useEffect, useState } from 'react';
import { usePlaystationPreview } from './usePlaystationPreview';
import { useTizenPreview } from './useTizenPreview';
import { useSearchParams } from 'react-router-dom';
import { useAppFeaturesContext } from '../../contexts/AppFeaturesContext/AppFeaturesContext';
import { LAUNCHER_REDIRECT } from '../../constants';

const useDeviceRedirects = () => {
  const { mode } = useAppFeaturesContext();

  const [deeplink, setDeeplink] = useState<string | null>(null);

  const [, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (deeplink === null || !deeplink.length) return;

    setSearchParams(prev => {
      prev.set(LAUNCHER_REDIRECT, deeplink);
      return prev;
    });

    setDeeplink(null);
  }, [deeplink, setSearchParams]);

  useTizenPreview(mode, setDeeplink);
  usePlaystationPreview(mode, setDeeplink);

  return {
    setPreviewRedirect: setDeeplink,
  };
};

export default useDeviceRedirects;
